<template>
    <div v-click-outside="hide" class="sidebar-other-menu">
        <div class="fixed pin-l pin-b block bg-accent-clay-orange-darkest">
            <button
                class="sidebar-other-btn outline-none"
                @click="expanded = ! expanded"
            >
                <font-awesome-icon
                    icon="bars"
                    size="2x"
                    class="mb-sm mx-auto"
                />
                Övrigt
            </button>
        </div>

        <div v-if="expanded" class="submenu submenu-other-menu">
            <slot />
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {

        directives: {
            ClickOutside,
        },
        data() {
            return {
                expanded: false,
            };
        },

        methods: {
            hide() {
                this.expanded = false;
            },
        },
    };
</script>